import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AbstractService } from "../../../../services/abstract.service";
import { environment as env } from "../../../../../environments/environment.prod";
import { OrderAttributes } from "@albatrosdeveloper/ave-models-package";
import { IOrderAttributes, IUpdateOrder } from "../update-order/interfaces/update-order.interface";
import { IDesunifyOrder, IDetailOrden, IFlowDocumentRequest } from "../../monitor/table-load-list/interfaces/detailOrderUpdate.interface";
import { IRequestResult } from "app/common/interfaces";
import { IOutboundDelivery } from "../../monitor/table-load-list/interfaces/outboud_delivery.interface";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";

const orderUrl = env.API_AVE_ORDER_URL + "api/";
const moduleName = "order/";

@Injectable({
  providedIn: "root",
})
export class UpdateOrderService extends AbstractService<
  OrderAttributes,
  Partial<OrderAttributes>,
  Partial<OrderAttributes>
> {
  constructor(http: HttpClient) {
    super(orderUrl, moduleName, http);
  }

  updateOrder(
    _id: string,
    dataToUpdate: IUpdateOrder
  ): Observable<{ data: OrderAttributes }> {
    let API_URL: string = `${orderUrl}order/v2/${_id}`;
    return this.http.patch<{ data: OrderAttributes }>(API_URL, dataToUpdate);
  }

  updateBaseUnit(detailOrden: IDetailOrden) {
    let API_URL: string = `${orderUrl}distribution_stock/update_distribution_charge`;

    return this.http.post<IRequestResult<OrderAttributes>>(
      API_URL,
      detailOrden
    );
  }

  updateOutboundDelivery(detailOrden: IOutboundDelivery) {
    let API_URL: string = `${orderUrl}distribution_stock/update_outbound_delivery`;

    return this.http.post<IRequestResult<OrderAttributes>>(
      API_URL,
      detailOrden
    );
  }

   desunifyOrder(
    serial: IDesunifyOrder
  ): Observable<{ data: OrderAttributes }> {
    let API_URL: string = `${orderUrl}${moduleName}disunify_order`;
    return this.http.post<{ data: OrderAttributes }>(API_URL, serial);
  }

  
   flowDocument(
    flow: IFlowDocumentRequest
  ): Observable<{ data: ( {
    sourceDocuments: OrderAttributes[];
    nextDocuments: IOrderAttributes[];
    serial: string;
    payments?: OrderPaymentAttributes[];
  } )[] }> {
    let API_URL: string = `${orderUrl}${moduleName}get_documents_related`;
    return this.http.post<{ data: ( {
      sourceDocuments: OrderAttributes[];
      nextDocuments: IOrderAttributes[];
      serial: string;
    } )[] }>(API_URL, flow);
  }

}
